import BaseComponent from "./BaseComponent";
import ReactDOM from "react-dom";
import Input from "./Input";

export default class TagList extends BaseComponent {
    /**
     * Display a list of items with customizable item view
     * @module TagList
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.state = {
            label: this.props.label ? this.props.label : "",
            items: this.props.value ? JSON.parse(JSON.stringify(this.props.value)) : []
        };
        this.headerCallbacks = {};
        this.headerCache = {};
    }

    /**
     * Add to list
     * @param {*} itemData
     */
    add(itemData){
        this.setState((prevState) => {
            const items = [...prevState.items, itemData];
            this.updateContext(items);
            return {items: items};
        });
    }

    /**
     * Remove item at index
     * @param {number} index
     */
    remove(index){
        this.setState((prevState) => {
            var items = [];
            if (index === 0){
                items = [...prevState.items.slice(1)];
            } else if (index === prevState.items.length - 1){
                items = [...prevState.items.slice(0, index)];
            } else {
                items = [...prevState.items.slice(0, index), ...prevState.items.slice(index + 1)];
            }
            this.updateContext(items);
            return {items: items};
        });
    }

    /**
     * Update item at index
     * @param {*} itemData
     * @param {number} index
     */
    update(itemData, index){
        this.setState((prevState) => {
            const items = prevState.items;
            items[index] = itemData;
            this.updateContext(items);
            return {items: items};
        });
    }

    /**
     * General renderer for item list
     * @param {Array} itemList
     * @param {Object} header
     * @returns {XML}
     */
    renderList(itemList, header = null){
        return (
            <div className={"form-component-container"} style={{position: "relative"}}>
                <label>{this.props.label}</label>
                {header}
                {(() => {
                    if (itemList.length > 0){
                        return (
                            <div style={{position:"relative"}}>
                                <ul className={"form-list"} style={{display:"inline-block"}}>{itemList}</ul>
                            </div>
                        );
                    }
                })()}
            </div>
        );
    }

    setConfig(key, value){
        if (this.headerCallbacks[key]){
            this.headerCallbacks[key](value);
        }
    }

    getConfig(key){
        return this.headerCache[key];
    }

    /**
     * React render
     * @returns {XML}
     */
    render(){
        this.headerCallbacks = {};
        const itemList = [];
        if (this.props.view === "intent"){
            const header =
                <Input hint={window.l.form.type_to_add_intent_category} context={this} valKey={"newIntent"} suggestion={"intent"}/>;
            this.headerCallbacks["newIntent"] = (value) => {
                if (value !== this.props.context.getID()){
                    this.add(value);
                }
                this.headerCache["newIntent"] = "";
            };
            for (var i = 0; i < this.state.items.length; i++){
                itemList.push(<IntentTagItem data={this.state.items[i]} context={this} varIdx={i} key={i} />);
            }
            return this.renderList(itemList, header);
        }
    }
}

/**
 * Base class of list item
 * @class ListItem
 */
class TagItem extends BaseComponent {
    /**
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.state = {
            showJsx: false
        }
    }

    /**
     * Get reference of list item itself
     * @returns {jQuery}
     */
    getDomSelf(){
        return $(ReactDOM.findDOMNode(this)).find(".tag-item");
    }

    /**
     * Hide attached submenu
     */
    removeSubmenu(){
        this.setState({ showJsx: false });
    }
}

/**
 * @class IntentTagItem
 */
class IntentTagItem extends TagItem {
    render(){
        var intName = "???";
        var icon = <i className={"fe icon-radio"} />;
        const node = window.apm.getNode(this.props.data);
        if (node){
            intName = node.name;
            icon = <i className={"fe icon-" + node.props.iconClass} />;
        }
        return (
            <li className={"tag-item"}>
                <div className={"tag-item-container"}>
                    <div>
                        {icon}{intName}
                        <i className={"fe icon-x caution"}
                           onClick={event => {
                               this.props.context.remove(this.props.varIdx);
                           }}
                        />
                    </div>
                </div>
            </li>
        );
    }
}